{
  "account-page-container": {
    "text": {
      "account": "Můj účet",
      "logout": "Odhlášení",
      "my-appointments": "Moje schůzky",
      "my-profile": "Můj profil",
      "my-salons": "Moje salony"
    }
  }
}
